/** 
 * @description: 不满一小时按小时计算
 * @author: cyp
 * @update: hwx
 */
<template>
	<div class="setting_manage">
		<!-- 列表 -->
		<div class="setting_list" v-show="showlist">
			<div class="table-responsive" >
				<table ref="setting_manage_table" class="table table-bordered table-hover" data-pagination="true"></table>
			</div>
		</div>
		<!-- 修改 -->
		<div class="details_content" v-show="!showlist">
			<div class="page_header">计时单价不满一小时按一小时算</div>
			<div class="row rowpadding">
				<label class="col-md-1 control-label" style="width: 100px;">门店:</label>
				<div class="col-md-4">
					<input class="form-control input-readonly canselect" v-model="shop_name" readonly="readonly" display="display">
				</div>
			</div>
			<div class="row" style="margin-bottom: 26px;">
				<label class="col-md-1 control-label" style="width: 170px;">不满一小时按一小时算:</label>
				<div class="col-md-4" style="line-height: 32px;">
					<input type="radio" name="ismenu" class="radiobig" value="-1" v-model="fullhours">
					<label class="control-label">否</label>
					<input type="radio" name="ismenu" class="radiobig" value="1" v-model="fullhours" style="margin-left: 30px;">
					<label class="control-label">是</label>
				</div>
			</div>
			<div class="row rowpadding des">
				注：<br />1.计时单价不满一小时按一小时算:<br />【是】包厢首次开房后消费不满足一个小时，按照一个小时的计时单价收费<br />【否】消费多少分钟按照多少分钟计算
			</div>
			<div class="row" style="padding-top: 30px;">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun()">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange"style="margin-left: 40px;" @click="update_setting()">保存</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'setting_manage',
		data() {
			return {
				showlist: true,
				shop_id: "",
				shop_name: "",
				fullhours: 1,
			}
		},
		mounted: function() {
			this.innitable();
		},
		methods: {
			innitable: function() {
				var _this = this;
				var actionEvents = {
					'click .edit': function(e, value, row, index) {
						_this.shop_name=row.shop_name;
						_this.shop_id=row.shop_id;
						_this.showlist=false;
						_this.fullhours=row.timing;
					}
				};
				$(_this.$refs.setting_manage_table).bootstrapTable('destroy');
				$(_this.$refs.setting_manage_table).bootstrapTable({
					pageSize: 10,
					pageList: [],
					ajax: function(params) {
						_this.getSettinglistdata(params);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						width: "34%",
						field: "shop_name",
						title: "门店"
					}, {
						width: "33%",
						field: "timing",
						title: "不满一小时按一小时算",
						formatter: function(value, index) {
							value=(value==1)?"是":"否";
							return value;
						}
					}, {
						width: "33%",
						title: "操作",
						events: actionEvents,
						formatter: _this.actionFormatter
					}],
				});
			},
			// 操作列格式化
			actionFormatter: function(value, row, index) {
				return [
					'<div class="orange-text">',
					'<a class="edit">修改</a></div>'
				].join('');
			},
			getSettinglistdata : function(params) {
				var pageNumber=1;
				var _this=this;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				var layIndex = layer.load(0, {
					shade: [0.1, '#ececec']
				});
				var datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": "10",
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl+"shop/getTimeRule",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code']=="true"){
							params.success({
								total: data['response']['result']['count'],
								rows: data['response']['result']['list']
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
							params.success({
								total: 0,
								rows: []
							});
						}
						layer.close(layIndex);
					},
					error: function(err) {
						layer.close(layIndex);
					}
				});
			},
			// 返回
			backFun: function(mark) {
				this.showlist = true;
				$(this.$refs.setting_manage_table).bootstrapTable('refresh');
			},
			update_setting: function(status) {
				var _this = this;
				var datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": this.shop_id,
							"timing": this.fullhours || "",
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "shop/editTimeRule",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							layer.msg(data["response"]["error_msg"]);
							$(_this.$refs.setting_manage_table).bootstrapTable('refresh');
							_this.showlist = true;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
					}
				});
			},
		}
	}
</script>
<style lang="less">
	.setting_manage {
		.row_magin_bottom {
			margin-bottom: 50px;
		}
		.control-label {
			text-align: right;
			line-height: 32px;
			font-size: 14px;
			font-weight: normal;
			color: #5e5e5e;
			padding-left: 0;
			padding-right: 0;
		}
		.bsSuggest_input {
			background: #fff!important;
		}
		.des {
			padding-left: 26px;
			color: rgb(156, 156, 156);
			padding-top: 20px;
			line-height: 32px;
		}
	}
</style>